import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac89891"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-account px-10 mb-20" }
const _hoisted_2 = { class: "login-account__wrapper text-center pa-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-10" }, "Вход", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-gradient text-center mb-20 d-inline-flex" }, "Авторизация", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-gradient text-center mb-20 d-inline-flex"
}
const _hoisted_6 = { class: "text-gradient d-inline-flex flex-direction-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Забыли пароль?")
], -1))
const _hoisted_9 = { class: "text-center mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Еще нет аккаунта?")
], -1))

import BaseInput from '@/components/Inputs/BaseInput.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import BackLine from '@/components/Lines/BackLine.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import { useAuthStore } from '@/stores/auth'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SocLinks from '@/components/SocLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const authStore = useAuthStore()
const router = useRouter()
const route = useRoute()
const errors = ref<any>({})
const isLoading = ref<boolean>(false)
const username = ref<string>('')
const password = ref<string>('')
const isAuth = computed(() => authStore.isAuth)

const inFocus = () => {
  errors.value = {}
}

const setLoading = (status: boolean) => {
  isLoading.value = status
}
const onSubmit = async () => {
  setLoading(true)
  const result = await authStore
    .login({
      username: username.value,
      password: password.value
    }).finally(() => setLoading(false))

  if (result.error) {
    errors.value.detail = 'Неверный логин или пароль.'
  }
  authStore.setAuth(result)
  if (isAuth.value) {
    await router.push(route.redirectedFrom?.path || '/login/success')
  }
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        _createVNode(CircleButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
          name: "chevron-left-gradient",
          bg: "empty",
          iconWidth: 21,
          iconHeight: 16,
          "view-box": "0 0 21 16"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("form", {
          class: "create-account__form",
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          enctype: "multipart/form-data"
        }, [
          (errors.value?.detail)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(errors.value?.detail), 1))
            : _createCommentVNode("", true),
          _createVNode(BaseInput, {
            onFocusin: inFocus,
            modelValue: username.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event)),
            type: "text",
            class: "mb-10 full-width",
            placeholder: "Ник / Почта"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseInput, {
            onFocusin: inFocus,
            modelValue: password.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            type: "password",
            class: "mb-10 full-width",
            placeholder: "Пароль"
          }, null, 8, ["modelValue"]),
          _createVNode(BaseButton, {
            disabled: isLoading.value || !!Object.keys(errors.value).length,
            class: "large rounded margin-auto mb-20 full-width",
            bg: "gradient",
            border: "gradient"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Войти")
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 32),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("h5", _hoisted_9, [
            _createVNode(_component_router_link, { to: {name: 'login-restore'} }, {
              default: _withCtx(() => [
                _createTextVNode("Восстановить")
              ]),
              _: 1
            })
          ]),
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("h5", null, [
            _createVNode(_component_router_link, { to: {name: 'login-register'} }, {
              default: _withCtx(() => [
                _createVNode(BaseButton, {
                  class: "large rounded",
                  bg: "none",
                  border: "gradient",
                  color: "gradient"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Зарегистрироваться")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(SocLinks)
    ])
  ], 64))
}
}

})